export default function WhatsAppChatBtn() {
	return (
		<a id="whatsapp-chat" href="https://wa.me/0000000000?text=Hello%20TechCorp%20">
			<p>Hi! How can I help you?</p>
			<span className="sr-only">Open WhatsApp</span>
		</a>
	);
}